import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import cartIcon from "../assets/images/cart.png";
import emptyCartIcon from "../assets/images/empty-cart.png";
import { toggleCartAction } from "../redux/actions/uiActions";
import { trimString } from "../helpers/helperFunctions";
import { toast } from "react-toastify";
import {
  deleteCart,
  getCartItems,
  modifyCart,
  updateCart,
} from "../redux/actions/cartActions";
import {
  BACKEND_BASE_PATH,
  REACT_APP_IMAGE_BASE_PATH,
} from "../helpers/config";
import { isAuthenticated } from "../auth";
import { checkCartProceed } from "../services/HomePageService";
const CartToggleComponent = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCartItems());
  }, []);
  const handleCartToggle = (e) => {
    e.preventDefault();
    dispatch(toggleCartAction());
  };
  const myCartData = useSelector((state) => state.cartReducer.result) || {};
  const { cartItems } = myCartData;
  let cartCount = 0;
  if (cartItems) {
    cartCount = cartItems.length;
  }

  const [countState, setCount] = useState(0);
  const [cartData, setCartData] = useState({});
  useEffect(() => {
    setCount(cartCount);
    setCartData(myCartData);
  }, [myCartData, cartCount]);

  return (
    <>
       <div className={"header_cart order-1 mob-d-deactive"}>
        <a
          href="/"
          className="cart__btn hover-btn pull-bs-canvas-left"
          title="Cart"
          onClick={handleCartToggle}
        >
          <img src={cartIcon} alt="cart" />
          <span className="noti_count2">{countState}</span>
        </a>
      </div> 
       <a
          href="/"
          className={ `mob-d-active navitem`}
          title="Cart"
          onClick={handleCartToggle}
          data-clr="#e4ecfa"
        >
          <div className="indicator"></div>
          <div className="hoverindicator"></div>
          <i className='f7--cart-fill'></i>
          <span className="noti_count2">{countState}</span>
        </a>

      <CartDrawer
        handleCartToggle={handleCartToggle}
        cartCount={countState}
        data={cartData}
      />
    </>
  );
};

const CartDrawer = ({ handleCartToggle, cartCount, data }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sideDrawerReducer.cartDraw);
  const { subTotal, totalSaving, cartItems, totalAvailability,minorder } = data;
  const [delLoader, setDelLoader] = useState("");
  const [countLoader, setCountLoader] = useState("");
  const deleteCartItem = async (data) => {
    setDelLoader(data.id);
    const delRes = await deleteCart(data);
    if (delRes) {
      dispatch(updateCart(delRes));
    }
    setDelLoader("");
  };
  const updateCount = async (data) => {
    setCountLoader(data.id);
    const delRes = await modifyCart(data);
    if (delRes) {
      dispatch(updateCart(delRes));
    }
    setCountLoader("");
  };
  const handleCheckout = async (e) => {
    e.preventDefault();
    if (totalAvailability > 0) {
      toast.error(
        "One Or More Product Not In Stock .Remove the product before Proceed to Checkout"
      );
      return false;
    } else {
      handleCartToggle(e);
      const cartProceed = await checkCartProceed(); //TOP, MIDDLE, BOTTOM, category id, page( 1=home, 2=category page)

      if (cartProceed.status == 300) {
        toast.error(
          "One Or More Product Not In Stock. Remove the product before Proceed to Checkout"
        );
      } else if (cartProceed.status == 479) {
        toast.error(cartProceed.message);
      }else if (cartProceed.status == 475) {
        toast.error(cartProceed.message);
      } else if (cartProceed.status == 200) {
        if (isAuthenticated()) {
          history.push("/checkout");
        } else {
          history.push({
            pathname: "/login",
            state: { callBackUrl: "/checkout" },
          });
        }
      }
    }
  };

  return (
    <div
      className={classNames(
        "bs-canvas bs-canvas-left position-fixed bg-cart h-100",
        { "mr-0": show }
      )}
    >
      <div className="bs-canvas-header side-cart-header p-3 ">
        <div className="d-inline-block  main-cart-title">
          My Cart <span>({cartCount} Items)</span>
        </div>
        <button
          type="button"
          className="bs-canvas-close close"
          aria-label="Close"
          onClick={handleCartToggle}
        >
          <i className="uil uil-multiply"></i>
        </button>
      </div>
      <div className="bs-canvas-body">
        {cartCount === 0 ? (
          <div className="empty-cart">
            <img src={emptyCartIcon} alt="empty" />

            <h3>Your shopping cart looks empty</h3>

            <div className="start-btn">
              <a href="/">Start Shopping</a>
            </div>
          </div>
        ) : (
          <div className="side-cart-items">
            {cartItems &&
              cartItems.map(
                ({
                  id,
                  image,
                  sku,
                  name,
                  price,
                  display_price,
                  product_id,
                  quantity,
                  slug,
                  availability,
                  options,
                  status,
                  maximumOrderQuantity,
                }) => (
                  <div
                    className={
                      "cart-item " + (availability == 0 ? "not_available" : "")
                    }
                    key={id}
                  >
                    <div className="cart-product-img">
                      <a href={`/product/${sku}/${slug}`}>
                        <img
                          src={`${REACT_APP_IMAGE_BASE_PATH}/${image}`}
                          alt={`${name} icon`}
                        />
                      </a>
                    </div>
                    <div className="cart-text">
                      {availability == 0 ? (
                        <p className="product_not_stock">
                          This product not in stock
                        </p>
                      ) : (
                        ""
                      )}
                      <h4>
                        <a href={`/product/${sku}/${slug}`}>
                          {trimString(name)}
                        </a>
                      </h4>
                      <div className="cart-radio">
                        {options && options.length > 0 ? (
                          <ul className="kggrm-now checkout-atr-list">
                            {options.map(
                              (
                                {
                                  attr_id,
                                  attr_name,
                                  attr_value_id,
                                  attr_value_name,
                                },
                                idx
                              ) => (
                                <li key={`${attr_value_name}_${product_id}`}>
                                  {attr_value_name}
                                </li>
                              )
                            )}
                          </ul>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="qty-group">
                        <div className="quantity buttons_added">
                          <input
                            type="button"
                            value="-"
                            className="minus minus-btn"
                            onClick={() =>
                              updateCount({
                                id,
                                product_id,
                                quantity: quantity - 1,
                              })
                            }
                            disabled={quantity <= 1}
                          />
                          {countLoader === id ? (
                            <span className="spinner-border" />
                          ) : (
                            <input
                              type="number"
                              step="1"
                              name="quantity"
                              value={quantity}
                              className="input-text qty text"
                            />
                          )}
                          <input
                            type="button"
                            value="+"
                            className="plus plus-btn"
                            onClick={() =>
                              updateCount({
                                id,
                                product_id,
                                quantity: quantity + 1,
                              })
                            }
                            disabled={quantity >= maximumOrderQuantity}
                          />
                        </div>
                        <div className="cart-item-price">
                          {display_price !== price ? (
                            <>
                              <span>AED {price}</span> AED {display_price}
                            </>
                          ) : (
                            <>AED {price}</>
                          )}
                        </div>
                      </div>

                      <button
                        onClick={() =>
                          deleteCartItem({ id, product_id, quantity })
                        }
                        type="button"
                        className="cart-close-btn"
                      >
                        {delLoader === id ? (
                          <span className="spinner-border" />
                        ) : (
                          <i className="uil uil-multiply"></i>
                        )}
                      </button>
                    </div>
                  </div>
                )
              )}
          </div>
        )}
      </div>
      {cartCount > 0 ? (
        <div className="bs-canvas-footer">
          <div className="cart-total-dil saving-total ">
            <h4>Total Saving</h4>
            <span>AED {totalSaving}</span>
          </div>
          <div className="main-total-cart">
            <h2>Total</h2>
            <span>AED {subTotal}</span>
          </div>
          <div className="checkout-cart">
            <Link
              onClick={handleCheckout}
              to="/checkout"
              className="cart-checkout-btn hover-btn"
            >
              Proceed to Checkout
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CartToggleComponent;
